module.exports = __webpack_public_path__ + "static/benefits-img4-8fa518e934b85a8ada748c1ff108fa5a.png";